import type { SyncState } from '@xavior/contracts';

export interface CalendarSyncView {
  connected: boolean;
  initialSyncComplete: boolean;
  syncing: boolean;
}

export function deriveCalendarSyncView(state: SyncState): CalendarSyncView {
  const connectedAccounts = state.accounts.filter((a) => a.connected);
  const connected = connectedAccounts.length > 0;
  // "Have we landed any data yet?" — true once ANY connected account finishes its
  // first sync. `some` (not `every`) so adding a second, not-yet-synced account
  // doesn't revert a calendar that already shows the first account's events.
  const initialSyncComplete = connectedAccounts.some((a) => a.initialSyncComplete);
  const syncing = connectedAccounts.some((a) => a.status === 'syncing' && !a.initialSyncComplete);
  return { connected, initialSyncComplete, syncing };
}
